import { observer } from "mobx-react-lite";
import * as React from "react";
import { Link } from "react-router-dom";
import { classNames } from "src/common/classNames";
import { IconRenderer } from "src/pages/ManagementPage/Menu2Tab/IconRenderer";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import styles from "./LeftMenu.module.less";
import { leftMenuStore as store } from "./leftMenuStore";
import { makeMenuItemKey } from "./makeMenuItemKey";
import { ZMenuItem } from "./ZMenuItem";
import { getFilterRestrictionQuery } from "./getFilterRestrictionQuery";

type MenuItemLabelProps = {
  item: ZMenuItem;
};

export const MenuItemLabel: React.FC<MenuItemLabelProps> = observer(
  ({ item }) => {
    const { name, iconName, link, id } = item;
    const key = makeMenuItemKey(id);
    const labelStyle = classNames([
      styles.menuItemLabel,
      [store.activeMenuElement === key, styles.menuItemLabelActive],
    ]);
    const labelContent = (
      <>
        <IconRenderer iconKey={iconName ?? ""} />
        <span className={styles.menuItemName}>{name}</span>
      </>
    );

    const renderLink = (to: string) => (
      <Link to={to} onClick={(e) => e.stopPropagation()} className={labelStyle}>
        {labelContent}
      </Link>
    );

    switch (link.type) {
      case "internal":
        return renderLink(makeUrl(link.url as PageUrl));
      case "object":
        return renderLink(
          makeUrl(
            PageUrl.entities,
            { objectId: link.objectId },
            getFilterRestrictionQuery(link),
          ),
        );
      case "external":
        return (
          <a href={link.href} className={labelStyle}>
            {labelContent}
          </a>
        );
      default:
        return <div className={labelStyle}>{labelContent}</div>;
    }
  },
);
